import { render, staticRenderFns } from "./questionTitle.vue?vue&type=template&id=23e4981d&"
import script from "./questionTitle.vue?vue&type=script&lang=js&"
export * from "./questionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports